// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3A-8J","unreadBadge":"styles_unreadBadge__9uUvz","modalContent":"styles_modalContent__t1Uvp","modal":"styles_modal__1DHUd"};